// @ts-nocheck
/**
 * AgKitOrderGrid — Order By Kit grid wrapper
 *
 * Thin wrapper around BaseOrderGrid with Kit-page-specific configuration:
 * Store-centric columns (rows are stores within a Kit), multi-row selection,
 * availability capping, metrics bar.
 */
import React from 'react';
import BaseOrderGrid, { MetricConfig } from 'pages/orderBySku/components/baseOrderGrid';
import { KIT_COL_CONFIG, KIT_GROUP_OPTIONS, EXCLUDED_GRID_FIELDS, ORDER_KITS_TABLE_ID } from '../constants';

interface Props {
	data: Record<string, any>[];
	onOrderQtyChange?: (rowIdx: number, storeId: string, newQty: number) => void;
	onSelectionChanged?: (selectedRows: Record<string, any>[]) => void;
	groupableColumns?: { key: string; label: string }[];
	kitAvailQty?: number;
	shelfQtyField?: string;
	kitLabel?: string;
	kitDesc?: string;
	kitOrdTotal?: number;
	kitRemain?: number;
	gridApiRef?: React.MutableRefObject<any>;
}

const KIT_METRICS_CONFIG: MetricConfig[] = [
	{ label: 'STORES', valueFn: (d) => new Set(d.map((r) => r.Store).filter(Boolean)).size, color: '#1565c0' },
	{ label: 'WAREHOUSES', valueFn: (d) => new Set(d.map((r) => r.Warehouse).filter(Boolean)).size, color: '#6a1b9a' },
];

const AgKitOrderGrid: React.FC<Props> = ({
	data,
	onOrderQtyChange,
	onSelectionChanged,
	groupableColumns,
	kitAvailQty,
	shelfQtyField,
	kitLabel,
	kitDesc,
	kitOrdTotal,
	kitRemain,
	gridApiRef,
}) => {
	return (
		<BaseOrderGrid
			data={data}
			colConfig={KIT_COL_CONFIG}
			groupOptions={KIT_GROUP_OPTIONS}
			excludedFields={EXCLUDED_GRID_FIELDS}
			onOrderQtyChange={onOrderQtyChange}
			entityIdField="Store"
			shelfQtyField={shelfQtyField}
			availabilityQty={kitAvailQty}
			selectionMode="multiRow"
			onSelectionChanged={onSelectionChanged}
			metricsConfig={KIT_METRICS_CONFIG}
			groupableColumns={groupableColumns}
			gridApiRef={gridApiRef}
			tableId={ORDER_KITS_TABLE_ID}
		/>
	);
};

export default AgKitOrderGrid;
